import React from "react";
import { IPriceClass } from "types/product";
import { connect } from "react-redux";
import { Actions as cartActions } from "reducers/cart";
import cn from "classnames";
import {Link} from "react-router-dom";
import {normalizePrice} from "utils/helpers";

import Counter from "components/Counter";
import SelectClass from "components/SelectClass";

import DeleteImg from "img/delete.svg";

interface ICartProduct {
  no: number;
  product_id: number;
  name: string;
  description: string;
  category_id: number;
  car_classes_id: number;
  quantity: number;
  product_price_classes: IPriceClass[];
  image: string;
  discount?: number;
  deleteFromCart: (no: number) => void;
  updateProduct: (
    payload: { no: number; car_classes_id: number; quantity: number;}
  ) => void;
  setDiscount: (payload: {no: number, discount: number}) => void;
  agent_fee_pct: number;
  top_discount_pct: number;
  top_agent_fee_pct: number;
  cartPrices: any;
}

const CartProduct: React.SFC<ICartProduct> = ({
  discount = 0,
  top_discount_pct = 0,
  agent_fee_pct = 0,
  top_agent_fee_pct = 0,
  cartPrices,
  ...props
}) => {

  const carClass = props.product_price_classes.find(
    i => i.car_class_id === props.car_classes_id
  );

  const handleChangeClass = (value: IPriceClass) => {
    props.updateProduct({
      no: props.no,
      car_classes_id: value.car_class_id,
      quantity: props.quantity,
    });
  };

  const regDiscount = /^\d*([,.])?(\d{1,2})?$/; //валидация поля скидки на ввод числа с плавающей точкой

  const handleChangeCount = (value: number) => {
    props.updateProduct({
      no: props.no,
      car_classes_id: props.car_classes_id,
      quantity: value,
    });
  };

  const handleChangeDiscount = (value: any) => {
    value = value.replace(/,/, '.');
    const valueParts = value.split('.');
    if ((!valueParts[1] || valueParts[1].length < 3) && regDiscount.test(value)) {
      if (value.startsWith('.')) value = '0' + value;
      if (valueParts[0].length > 1 && value[0] === '0') value = value.replace(/0/, '');

      props.setDiscount({no: props.no, discount: value});
    }
  }

  const handleDeleteProduct = () => {
    props.deleteFromCart(props.no);
  }

  return (
    <div className="shopcart___  cart-product">
      <div className="cont card">
        <div
          className="delete-product"
          onClick={handleDeleteProduct}
        >
          Убрать товар <img className="delete-product-img" src={DeleteImg} />
        </div>
        <div className="row no-gutters d-flex justify-content-around  d-flex align-items-center">
          <Link to={`/home/card/${props.product_id}`} className="col-xl-5 col-lg-12 col-12 link-style">
            <img src={props.image} className="prod card_pic" />
            <p className="sec___"> {props.name}</p>
          </Link>
          <hr className="col-12 d-block d-lg-none" />
          <div className="col-xl-1 col-lg-12 col-md-12 col-12 row align-items-center align-items-lg-end align-items-xl-start">
            <div className="col-lg-6 col-md-6 col-6 d-lx-none d-xl-none grey_colour">
              Цена, ₽
            </div>
            <div className="col-xl col-lg-6 col-md-6 col-6 bold_price_ text-right mt-xl-0">
              {normalizePrice(cartPrices.price)}
            </div>
          </div>
          <div className="col-xl-1 col-lg-12 col-md-12 col-12 row align-items-center">
            <div className="col-lg-6 col-md-6 d-lx-none d-xl-none col-6 grey_colour">
              Класс
            </div>
            <div className="col-xl col-lg-6 col-md-6 pl-0  col-6 text-right p-l____ cart-select right-side" >
              {carClass && carClass.car_class_id !== 0 &&
                <SelectClass
                  value={carClass!}
                  options={props.product_price_classes}
                  onChange={handleChangeClass}
                />
              }
            </div>
          </div>
          <div className="col-xl-1 col-lg-12 col-md-12 col-12 row align-items-center">
            <div className="col-lg-6 col-md-6 d-lx-none d-xl-none col-6 grey_colour">
              Кол-во
            </div>
            <div className="col-xl col-lg-6 col-md-6 col-6 pl-0 pr-0 text-right shop_c ">
              <Counter
                minCount={1}
                value={props.quantity}
                onChange={handleChangeCount}
              />
            </div>
          </div>
          <hr className="col-12 d-block d-lg-none" />

          <div className="col-xl-1 col-lg-12 col-md-12 col-12 text-center text_c_bug_ row align-items-center">
            <div className="col-lg-6 col-md-6 d-lx-none d-xl-none col-7 grey_colour left-side">
              Сумма скидки, ₽
            </div>
            <div className={cn("col-xl col-lg-6 col-md-6  mda___a_ col-5 text-right right-side", {'error___': cartPrices.error})}>
              <input
                className={cn("prod-class input_100 discount-input", {'input-error': cartPrices.error})}
                type="text"
                value={normalizePrice(discount)}
                onChange={(e) => handleChangeDiscount(e.target.value)}
                disabled={!cartPrices.price}
              />
            </div>
          </div>
          <div className="col-12 d-md-none row">
            <span className={cn("error-desc cart-product-error-desc", {'show-error-desc': cartPrices.error})}>
              Скидка не может превышать
              <span className="d-block" /> размер гонорара
            </span>
          </div>
          <div className="col-xl-1 col-lg-12 col-md-12 col-12 text-center text_c_bug_ row align-items-center align-items-lg-center">
            <div className="col-lg-6 col-md-6 d-lx-none d-xl-none col-6 grey_colour left-side">
              Бонус, Б
            </div>
            <div className="col-xl col-lg-6  bold_price_ green_text_ text_r_bug_ col-6 mt-xl-0 right-side">
              {normalizePrice(cartPrices.bonus)}
            </div>
          </div>
          <div className="col-xl-1 col-lg-12 col-md-12 col-12 text-center text_c_bug_ row align-items-center align-items-lg-center">
            <div className="col-lg-6 col-md-6 d-lx-none d-xl-none col-6 grey_colour left-side">
              Сумма, ₽
            </div>
            <div className="col-xl col-lg-6 bold_price_ text_r_bug_ col-6 mt-xl-0 right-side">
              {normalizePrice(cartPrices.summ)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const actions = {
  updateProduct: cartActions.updateProduct,
  deleteFromCart: cartActions.deleteFromCart,
  setDiscount: cartActions.setDiscount,
};

export default connect(
  null,
  actions
)(CartProduct);
